var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.63682 10.0821L2.25052 6.61134C1.96645 6.45704 1.631 6.46341 1.35302 6.62865C1.07505 6.79386 0.90918 7.08555 0.90918 7.40892V15.4603C0.90918 15.786 1.08509 16.0884 1.3683 16.2494L7.75471 19.8801C7.8955 19.9601 8.04945 20.0001 8.20344 20.0001C8.36037 20.0001 8.51725 19.9586 8.65991 19.8755C8.94246 19.7111 9.11114 19.4178 9.11114 19.0909V10.8797C9.11114 10.5467 8.92944 10.2411 8.63682 10.0821Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5961 4.51699C17.5956 4.17705 17.4078 3.86871 17.1061 3.7123L10.142 0.101876C9.87835 -0.0348841 9.56407 -0.0338682 9.30138 0.104416L2.43974 3.71484C2.14098 3.87211 1.95514 4.17951 1.95471 4.51715C1.95432 4.85471 2.13942 5.16254 2.43775 5.32048L9.29942 8.95344C9.43227 9.02374 9.57814 9.05891 9.72408 9.05891C9.86823 9.05891 10.0124 9.0246 10.1439 8.95595L17.1081 5.32306C17.4096 5.16582 17.5965 4.85694 17.5961 4.51699Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.311 6.62872C18.0332 6.46347 17.6975 6.45695 17.4136 6.61137L11.0271 10.0821C10.7346 10.2412 10.5529 10.5468 10.5529 10.8797V19.0909C10.5529 19.4178 10.7215 19.7112 11.0041 19.8756C11.1467 19.9586 11.3036 20.0001 11.4606 20.0001C11.6145 20.0001 11.7685 19.9601 11.9093 19.8801L18.2957 16.2495C18.5789 16.0884 18.7548 15.786 18.7548 15.4603V7.40899C18.7548 7.08561 18.5889 6.79392 18.311 6.62872Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModelIcon);
export default __webpack_public_path__ + "static/media/model-icon.73ce80cd196c9703d9c984b121099b45.svg";
export { ForwardRef as ReactComponent };